module.exports = __webpack_public_path__ + "img/img35.5578e9be.svg";